import { useState } from "react";
import type { ColumnDef, OnChangeFn, SortingState } from "@tanstack/react-table";
import TableDetailsPanel from "@/components/TableDetailsPanel";
import type { CommitteeTermNode } from "../types";

interface CommitteeTermsPanelProps {
  terms: CommitteeTermNode[];
  columns: ColumnDef<CommitteeTermNode, unknown>[];
}

export default function CommitteeTermsPanel({ terms, columns }: CommitteeTermsPanelProps) {
  const [sorting, setSorting] = useState<SortingState>([{ id: "endDate", desc: true }]);

  const handleSortingChange: OnChangeFn<SortingState> = (updaterOrValue) => {
    setSorting((currentSorting) =>
      typeof updaterOrValue === "function" ? updaterOrValue(currentSorting) : updaterOrValue
    );
  };

  return (
    <TableDetailsPanel
      data={terms}
      columns={columns}
      title={`Terms (${terms.length})`}
      sortingState={sorting}
      onSortingChange={handleSortingChange}
    />
  );
}
